import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  ImplementasiAskepRequest,
  ImplementasiAskepResponseItem
} from "@/types/cppt";

async function create(data: ImplementasiAskepRequest) {
  const response = await http
    .postData("/implementasi-askep", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function update(id: number, data: ImplementasiAskepRequest) {
  const response = await http
    .putData(`/implementasi-askep/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: ImplementasiAskepResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/implementasi-askep`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number, alasan: string) {
  const response = await http
    .deleteDataParam(`/implementasi-askep/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function searchHasilImplementasi(keyword: string) {
  const response = await http
    .getData(`/history-input/hasil-implementasi-askep?search=${keyword}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  destroy,
  searchHasilImplementasi
};
